export default __webpack_public_path__ + "static/media/ic_price_yellow.cdf74281.svg";